export const ALAO_ORGANIZATION_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'alao AG',
  url: 'https://www.alao.ch',
  logo: {
    '@type': 'ImageObject',
    url: 'https://d16jaymuycdk0d.cloudfront.net/fab352f6/_ipx/s_230x100/img/logos/alao.svg',
  },
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Ottikerstrasse 59',
    addressLocality: 'Zürich',
    postalCode: '8006',
    addressCountry: 'CH',
  },
  telephone: '+41435882323',
  email: 'support@alao.ch',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+41435882323',
    contactType: 'customer service',
    availableLanguage: ['German', 'French', 'English'],
  },
  sameAs: [
    'https://www.facebook.com/alaoSchweiz',
    'https://www.instagram.com/alao.ch',
    'https://x.com/alao_ch',
  ],
}

export const staticMetaInfo = {
  siteName: 'alao',
  email: 'support@alao.ch',
  twitter: '@alao_ch',
  copyrights: 'Copyright alao GmbH.  All rights reserved.',
  geo: {
    region: 'CH-ZH',
    placeName: 'Z&uuml;rich',
    latitude: 47.36428,
    longitude: 8.55231,
  },
  ogImage: {
    url: '/og-share.jpg',
    width: '1200',
    height: '630',
  },
}
